<template>
  <div class="401-not-authorized">
    <h2>401</h2>
    <p>You are not authorized to access this page.</p>
  </div>
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'

useHead({ title: 'Not Authorized' })
</script>
